import React from 'react';
import TimeAgo from 'react-timeago';
import styled from 'styled-components';
import { dateFormats } from '@nextinq/domain';

const AbsoluteDate = styled.span`
  padding-right: 9px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Timestamp(props: any) {
  const { value } = props;
  return (
    <span>
      <AbsoluteDate>{dateFormats.long.timestamp(value)}</AbsoluteDate>
      <TimeAgo date={value} live={false} />
    </span>
  );
}
